'use client';

import clsx from 'clsx';
import React, { FC, InputHTMLAttributes } from 'react';

import Icon from '../icon';
import styles from './styles.module.css';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  error?: string | null;
}

const Checkbox: FC<Props> = ({ checked, error, disabled, ...otherProps }) => {
  return (
    <label
      className={clsx(styles.checkbox, checked && styles.active, error && styles.error, disabled && styles.disabled)}
    >
      <Icon name="checkmark" className={styles.checkmark} />
      <input className={styles.input} type="checkbox" checked={checked} disabled={disabled} {...otherProps} />
    </label>
  );
};

export default Checkbox;
